import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getHomePath } from '../utils/permissions';

// Sends the user to their landing page: the dashboard with "dashboard.read",
// otherwise the orders list (see getHomePath).
const HomeRedirect = () => {
  const { user } = useSelector((state) => state.auth);
  return <Navigate to={getHomePath(user)} replace />;
};

export default HomeRedirect;
